// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {RefObject, useEffect, useState} from 'react';
import {get_height} from './screen_util';
import {use_in_view} from './use_in_view';

export type t_element_part = 'top'|'center'|'bottom';
type i_screen_position = Record<t_element_part, number|null>;
interface i_use_screen_position_options {
    rel?: boolean;
}
type t_use_screen_position = <T extends HTMLElement>(ref: RefObject<T>,
    opt:i_use_screen_position_options)=>i_screen_position;
export const use_screen_position: t_use_screen_position = (ref, opt = {})=>{
    const {rel = false} = opt;
    const visible = use_in_view(ref);
    const elem = ref.current;
    const [pos, set_pos] = useState<i_screen_position>({top: null,
        center: null, bottom: null});
    useEffect(()=>{
        const handle_scroll = ()=>{
            const rect = elem.getBoundingClientRect();
            let t = rect.top, c = t + rect.height / 2, b = rect.bottom;
            if (rel)
                t = t / wh; c = c / wh; b = b / wh;
            set_pos({top: t, center: c, bottom: b});
        };
        if (!elem || !visible)
        {
            window.removeEventListener('scroll', handle_scroll);
            return;
        }
        const wh = get_height();
        window.addEventListener('scroll', handle_scroll);
        handle_scroll();
        return ()=>{
            window.removeEventListener('scroll', handle_scroll);
        };
    }, [visible, elem]);
    return pos;
};
